module.exports = __webpack_public_path__ + "static/media/traffic-yes.93fd5640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/traffic-yes.svg
// module id = 873
// module chunks = 0